import { ElementType } from 'react';
import classNames from 'classnames';
import AccordionItem, { AccordionItemProps } from './AccordionItem';
import styles from './Accordion.module.scss';

export interface AccordionProps<T extends ElementType> {
  labelAs?: T;
  items: Omit<AccordionItemProps, 'labelAs' | 'isOpen' | 'onClick'>[];
  className?: string;
}

function Accordion<T extends ElementType = 'p'>({
  className,
  labelAs,
  items,
}: AccordionProps<T>) {
  return (
    <ul className={classNames(styles.container, className)}>
      {items.map((item, key) => (
        <AccordionItem {...item} labelAs={labelAs} key={key} />
      ))}
    </ul>
  );
}

export default Accordion;
